@if (isScreenNotSupported) {
  <app-screen-not-supported></app-screen-not-supported>
} @else {
  @defer (when userContextState.user().id) {
    <app-shell></app-shell>

    <ng-template #unsupportedBrowserTypeDialogTemplate>
      <div *transloco="let t; read: 'errors.unsupportedBrowserType'">
        <cw-banner type="info" [enableClose]="false">
          <span [innerHTML]="t('info') | sanitizeHTML"></span
        ></cw-banner>
      </div>
    </ng-template>

    <ng-template #unsupportedBrowserVersionDialogTemplate>
      <div *transloco="let t; read: 'errors.unsupportedBrowserVersion'">
        <cw-banner type="info" [description]="t('info')" [enableClose]="false">
          <span [innerHTML]="t('info') | sanitizeHTML"></span>
        </cw-banner>
      </div>
    </ng-template>
  } @placeholder (minimum 2000ms) {
    <cw-splash-screen appName="Device Management" [loading]="true" />
  }
  <app-sidebar />
}

<app-dialog />
